import { getHeaderManifest } from '@carvana/header';
import { MfeConfig, MfeLoad } from '@carvana/microfrontend';
import { MfeReact, MfeReactComponent } from '@carvana/microfrontend-react';
import { useEffect } from 'react';
import { environment, isLocalEnvironment } from '~/constants/environment';

export const getMfeCacheBuster = () => {
  const date = new Date();
  const nearestQuarterHour = Math.round(date.getMinutes() / 15) * 15;

  return `${date.getDate()}-${date.getHours()}-${nearestQuarterHour}`;
};

export function mfeConfigLoad(enableDebug: boolean) {
  return MfeConfig({
    name: 'search-ui',
    Render: MfeReact(),
    ENV: isLocalEnvironment ? 'local' : environment,
    debug: enableDebug,
    globals: {
      React: () => import('react'),
      ReactDOM: () => import('react-dom'),
      styled: () => import('styled-components'),
      PropTypes: () => import('prop-types'),
      'styled-components': () => import('styled-components'),
      'prop-types': () => import('prop-types'),
      carvanaExperiment: () => import('@carvana/experiment'),
      carvanaShowroomTheme: () => import('@carvana/showroom-theme'),
      classnames: () => import('classnames'),
      process: () => process
    },
    files: []
  });
}

export default function useMicroFrontend(enableDebug: boolean) {
  useEffect(() => {
    void mfeConfigLoad(enableDebug);
  }, [enableDebug]);
}

export function MfeComponent<OwnProps>(
  props: OwnProps & React.ComponentProps<typeof MfeReactComponent>
) {
  return <MfeReactComponent {...props} />;
}

export const loadHeaderMfe = () =>
  MfeLoad({
    files: [
      [
        'HeaderModule',
        [
          {
            component: 'default',
            default: {
              file: 'index.js',
              manifest: getHeaderManifest(environment)
            }
          }
        ]
      ]
    ]
  });

export const loadFooterMfe = () =>
  MfeLoad({
    files: [
      [
        'FooterModule',
        [
          {
            component: 'default',
            browser: true,
            default: {
              file: 'index.js',
              manifest: `${
                process.env.CVNA_APP_ASSETS_CDN
              }/footer/module/assets-manifest.json?v=${getMfeCacheBuster()}`
            }
          }
        ]
      ]
    ]
  });

export const loadActivationModalMfe = () =>
  MfeLoad({
    files: [
      [
        'CaActivationModal',
        [
          {
            component: 'default',
            default: {
              file: 'index.js',
              manifest: `${
                process.env.CVNA_APP_ASSETS_CDN
              }/activation-modal-module/assets-manifest.json?v=${getMfeCacheBuster()}`
            }
          }
        ]
      ]
    ]
  });
